<template>
  <section class="main-diff-section width">
    <article>
      <div class="flex-col-center sm-title">디버와 함께 하는 고객사</div>
      <div class="lg-title">
        다양한 기업들이 디버의 맞춤 배송을<br />
        경험하고 있습니다.
      </div>
    </article>

    <!-- 데스크탑, 태블릿 -->
    <div class="flex btn-bar">
      <div slot="button-prev" @click="slidePrev()">
        <img class="btn" src="@/assets/img/main/desktop/left_btn.png" />
      </div>
      <div slot="button-next" @click="slideNext()">
        <img class="btn" src="@/assets/img/main/desktop/right_btn.png" />
      </div>
    </div>
    <swiper
      class="swiper client-area for-desktop flex-col"
      :options="swiperOption"
    >
      <swiper-slide class="swiper-flex">
        <div v-for="i in 12" :key="i">
          <img
            class="logo-space"
            :src="require(`@/assets/img/main/client/1/logo_${i}.png`)"
          />
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-flex">
        <div v-for="i in 12" :key="i">
          <img
            class="logo-space"
            :src="require(`@/assets/img/main/client/2/logo_${i}.png`)"
          />
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-flex">
        <div v-for="i in 12" :key="i">
          <img
            class="logo-space"
            :src="require(`@/assets/img/main/client/3/logo_${i}.png`)"
          />
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-flex">
        <div v-for="i in 12" :key="i">
          <img
            class="logo-space"
            :src="require(`@/assets/img/main/client/4/logo_${i}.png`)"
          />
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

    <!-- 모바일 -->
    <swiper class="swiper client-area for-mobile" :options="swiperOption">
      <swiper-slide class="swiper-flex">
        <div v-for="i in 6" :key="i">
          <img
            class="logo-space"
            :src="require(`@/assets/img/main/client/1/logo_${i}.png`)"
          />
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-flex">
        <div v-for="i in [7, 8, 9, 10, 11, 12]" :key="i">
          <img
            class="logo-space"
            :src="require(`@/assets/img/main/client/1/logo_${i}.png`)"
          />
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-flex">
        <div v-for="i in 6" :key="i">
          <img
            class="logo-space"
            :src="require(`@/assets/img/main/client/2/logo_${i}.png`)"
          />
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-flex">
        <div v-for="i in [7, 8, 9, 10, 11, 12]" :key="i">
          <img
            class="logo-space"
            :src="require(`@/assets/img/main/client/2/logo_${i}.png`)"
          />
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-flex">
        <div v-for="i in 6" :key="i">
          <img
            class="logo-space"
            :src="require(`@/assets/img/main/client/3/logo_${i}.png`)"
          />
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-flex">
        <div v-for="i in [7, 8, 9, 10, 11, 12]" :key="i">
          <img
            class="logo-space"
            :src="require(`@/assets/img/main/client/3/logo_${i}.png`)"
          />
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-flex">
        <div v-for="i in 6" :key="i">
          <img
            class="logo-space"
            :src="require(`@/assets/img/main/client/4/logo_${i}.png`)"
          />
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-flex">
        <div v-for="i in [7, 8, 9, 10, 11, 12]" :key="i">
          <img
            class="logo-space"
            :src="require(`@/assets/img/main/client/4/logo_${i}.png`)"
          />
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </section>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  methods: {
    slidePrev() {
      const swiper = document.querySelector(".swiper").swiper;

      // Now you can use all slider methods like
      swiper.slidePrev();
    },
    slideNext() {
      const swiper = document.querySelector(".swiper").swiper;

      // Now you can use all slider methods like
      swiper.slideNext();
    },
  },
};
</script>
<style src="./mainCommon.css" scoped></style>
<style scoped>
.swiper-button-prev::after {
  display: none;
}

.swiper-button-prev {
  left: 0;
}
section {
  margin: 50px auto;
  display: flex;
  flex-direction: column;
}
.main-diff-section {
  height: 400px;
}

.swiper-flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
}

.logo-space {
  background: #f5faff;
  border-radius: 1rem;
  margin: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.page-row {
  display: flex;
  justify-content: center;
}

.btn {
  width: 40px;
  height: 40px;
  cursor: pointer;
  margin: 0 5px;
}

@media all and (min-width: 1281px) {
  article {
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
  .main-diff-section {
    height: 600px;
  }
  .client-area {
    height: 400px;
    width: 900px;
  }

  .logo-space {
    width: 128px;
    height: 128px;
  }

  .page-row {
    width: 900px;
    height: 142px;
  }

  .swiper-flex {
    width: 900px;
  }
  .prev-btn img {
    width: 40px;
    height: 40px;
    /* display: none; */
  }

  .btn-bar {
    height: 40px;
    width: 850px;
    margin: auto;
  }
}

@media all and (min-width: 769px) and (max-width: 1280px) {
  article {
    height: 220px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .main-diff-section {
    height: 500px;
  }
  .padding-0 {
    padding-left: 0 !important;
  }

  .client-area {
    height: 500px;
    margin: 50px 0;
  }

  .swiper-flex {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
  }

  .logo-space {
    width: 95px;
    height: 95px;
  }

  .btn-bar {
    display: none;
  }
}

@media all and (max-width: 768px) {
  article {
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
  .client-area {
    height: 400px;
    width: 347px;
  }

  .swiper-flex {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
  }

  .for-desktop {
    display: none;
  }

  .logo-space {
    width: 96px;
    height: 96px;
  }

  .btn-bar {
    display: none;
  }
}
</style>
